module.exports = __webpack_public_path__ + "img/wxzx.a15b3f10.png";